<ng-container *ngIf="chat$ | async as chat">
    <ng-container *ngLet="(isChatReady$ | async) === true as isChatReady">
        <vsc-public-event-card
            *ngLet="
                !isChatReady && chat.organizerId === memberId as isClickable
            "
            [publicEvent]="publicEvent$ | async"
            [orientation]="orientation"
            [horizontalCardActionsTemplateRef]="actionsTemplate"
            [clickable]="isClickable"
            (click)="isClickable && navigateToChatManage(chat.id)"
            (keydown.enter)="isClickable && navigateToChatManage(chat.id)"
            (keydown.space)="isClickable && navigateToChatManage(chat.id)"
            [attr.tabindex]="isClickable ? 0 : null"
            [attr.aria-label]="'Open ' + (chat?.title ?? 'Chat')"
        >
            <!-- Actions template -->
            <ng-template #actionsTemplate>
                <vsc-join-chat
                    #room
                    [chatId]="chat.id"
                    *ngIf="isChatReady"
                    (click)="$event.stopPropagation()"
                    aria-label="Join Chat"
                >
                </vsc-join-chat>
            </ng-template>
            <!-- /Actions template -->
        </vsc-public-event-card>
    </ng-container>
</ng-container>
